/* global gtag_report_conversion */
import React, { useEffect, useState } from "react";

import "../styles/hero.css";
import "../styles/common.css";
import { FiPhone } from "react-icons/fi";

import AOS from "aos";
import "aos/dist/aos.css";

const Hero = () => {
  useEffect(() => {
    AOS.init({
      duration: 700,
      once: true,
      offset: 80,
      easing: "ease-out",
    });
  }, []);

  return (
    <section className="hero-section overlay" data-aos="fade-in">
      <div className="container">
        <div className="">
          <h1
            className="hero-title text-center pt-lg-5 pt-xl-5"
            data-aos="zoom-in"
          >
            OLAJCSERESZOLNOK.HU
          </h1>

          <div className="container h-100">
            <div className="row h-100 align-items-start justify-content-center">
              <div className="col-lg-6 text-white text-center text-lg-start pt-lg-4">
                <h2
                  className="hero-subtitle pt-lg-5 mt-lg-5"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  Gyors olajcsere Szolnokon – megbízható autószerviz tapasztalt
                  szerelőktől
                </h2>

                <p className="lead" data-aos="fade-up" data-aos-delay="200">
                  Professzionális olajcsere, szűrőcsere, fékcsere és
                  állapotfelmérés – gyors kiszolgálás Szolnokon, rejtett
                  költségek nélkül.
                </p>

                <a
                  href="tel:+36300167381"
                  onClick={(e) => {
                    try {
                      if (typeof gtag_report_conversion === "function") {
                        gtag_report_conversion("tel:+36300167381");
                      }
                    } catch (err) {
                      console.error("gtag_report_conversion error:", err);
                    }
                  }}
                  className="contact-btn"
                  data-aos="zoom-in-up"
                  data-aos-delay="300"
                >
                  <FiPhone className="me-2" />
                  +36 30 016 7381
                </a>
              </div>

              <div
                className="col-lg-6"
                data-aos="fade-left"
                data-aos-delay="150"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
